import { signal } from "@preact/signals-react";

import ButtonAction from "componentsv2/button/ButtonAction";
import { PlusCircleIcon } from "components/Icons";
import UpdateFolio from "./UpdateFolio";
import { addNightView } from "./viewsFolioWizard";
import { useStore } from "storev2/formStore";

function FolioToolbar({ recordId }) {
  const model = "hotel.folio";
  const { reload } = useStore();

  function onClose() {
    reload(model, recordId);
  }

  const wizardAddNight = {
    name: "hotel.folio.add_night",
    views: addNightView,
    recordId: recordId,
  };

  const signalsAddNight = {
    nextMsg: signal(""),
    nextWidget: signal(null),
    nextButtons: signal([]),
  };

  return (
    <div id="toolbar-folio" className="flex gap-x-3">
      <ButtonAction
        label="hotel.folio.add_night"
        size="sm"
        wizard={wizardAddNight}
        stepSignals={signalsAddNight}
        styleBtn="border-neutral-800 text-neutral-800"
        icon={<PlusCircleIcon className="fill-current my-auto" />}
        openModal={signal(false)}
        onClose={onClose}
      />
      <UpdateFolio
        recordId={recordId}
        onClose={onClose}
        openModal={signal(false)}
      />
    </div>
  );
}

export default FolioToolbar;
